import { render, staticRenderFns } from "./Wp_user_banner.vue?vue&type=template&id=2326e376&scoped=true&"
import script from "./Wp_user_banner.vue?vue&type=script&lang=js&"
export * from "./Wp_user_banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2326e376",
  null
  
)

export default component.exports